import React from "react";
import { luxury } from "./data/luxury";
import VehicleFullCard from "./VehicleFullCard";

export default function Luxury() {
  return (



<>


<section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Luxury Cars </h1>
          </div>
        </div>
      </section>



    <div className="vehicle-page">
       <div className="vehicle-container">
         {luxury.map((v) => (
           <VehicleFullCard key={v.id} v={v} />
         ))}
       </div>
     </div>
     
</>
  );
}
